import { css } from '@emotion/css'
import { styled, alpha } from '@mui/material'

export const FooterSt = styled('footer')<{ primaryColor?: string }>(({ theme, primaryColor }) => {
  const base = primaryColor || theme.palette.primary.main
  return {
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(1, 2),
    // nice, subtle background & top border
    backgroundColor: theme.palette.background.paper,
    backgroundImage: `linear-gradient(180deg, ${alpha(base, 0.08)} 0%, transparent 100%)`,
    borderTop: `1px solid ${theme.palette.divider}`,
    boxShadow: `0 -4px 12px ${alpha(theme.palette.common.black, 0.06)}`,
    marginTop: 'auto', // Push footer to bottom when content is short
  }
})

export const ContentSt = styled('div')`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(1)};
`

export const versionSt = css`
  display: inline-flex;
  margin-left: auto;
`
